import { differenceInCalendarDays } from 'date-fns';

type DaysOnMarketSource = {
  daysOnMarket?: number | null;
  daysOnMarketRecordedAt?: string | null;
  updatedAt?: string | null;
};

/**
 * Extension snapshots DOM at scrape time. Add calendar days since that anchor
 * so "days on market" advances without re-scraping the listing.
 */
export function getLiveDaysOnMarket(
  source: DaysOnMarketSource | null | undefined
): number | undefined {
  if (source == null || source.daysOnMarket == null) return undefined;

  const snapshot = Math.max(0, Math.floor(source.daysOnMarket));
  const anchorRaw = source.daysOnMarketRecordedAt ?? source.updatedAt ?? null;
  if (!anchorRaw) return snapshot;

  const anchor = new Date(anchorRaw);
  if (Number.isNaN(anchor.getTime())) return snapshot;

  const elapsed = Math.max(0, differenceInCalendarDays(new Date(), anchor));
  return snapshot + elapsed;
}

export function formatDaysOnMarketLabel(days: number): string {
  const n = Math.max(0, Math.floor(days));
  return `${n} day${n === 1 ? '' : 's'} on market`;
}
